<div class="my-fender-welcome">
  <div class="fui-welcome-header">
    <myp-svg id="fender-logo" class="svg-brand-color m-b-20" width="200" height="80"></myp-svg>
    <h2 class="fui-heading-font t-30 text-center m-b-20">{{ steps[step].header }}</h2>
    <!-- <fui-heading level="2" fontSize="f9" [text]="steps[step].header"></fui-heading> -->
  </div>

  <div class="fui-welcome-content-container" [class.closed]="!initialAnimationDone" [class.open]="initialAnimationDone">
    <div class="fui-welcome-content" [class.animate-in-from-right]="shouldAnimateInFromRight" [class.animate-in-from-left]="shouldAnimateInFromLeft">
      <div class="fui-welcome-content-text">
        @if (step == 1) {
          <div class="d-flex justify-content-center align-items-center">
            <myp-svg id="fender-headstock" class="svg-neutral m-x-10" width="70" height="70"></myp-svg>
            <fa-icon icon="graduation-cap" class="m-x-10" style="font-size: 50px"></fa-icon>
            <fa-icon icon="users" class="m-x-10" style="font-size: 50px"></fa-icon>
          </div>
        }
        @if (step == stepsArray.length) {
          <div class="d-flex justify-content-center align-items-center">
            <button class="brand-btn" style="width: 300px" (click)="onLetsGoClick()">{{ "onboarding.lets_go" | translate }}</button>
          </div>
        }
        <div [class]="'step-' + step" [innerHTML]="steps[step].content | safe: 'html'"></div>
      </div>
    </div>

    <div class="fui-welcome-pagination" ngbAutoFocus>
      <button class="small-btn m-r-10" [disabled]="step == 1" [ngStyle]="{ opacity: step == 1 ? 0.1 : 1 }" (click)="changeStep(step - 1)"><fa-icon [icon]="'chevron-left'"></fa-icon></button>
      @for (page of steps | keyvalue; track page) {
        <div class="fui-welcome-pagination-item" [class.selected]="step == +page.key" (click)="changeStep(+page.key)"></div>
      }
      <button class="small-btn m-l-10" [disabled]="step == stepsArray.length" [ngStyle]="{ opacity: step == stepsArray.length ? 0.1 : 1 }" (click)="changeStep(step + 1)">
        <fa-icon [icon]="'chevron-right'"></fa-icon>
      </button>
    </div>

    @if (step != stepsArray.length) {
      <div class="p-t-50 text-center">
        <button class="small-btn" (click)="onSkipClick()">{{ "my_fender_welcome.skip" | translate }}</button>
      </div>
    }
  </div>
</div>
